import React from 'react';
import { VideoOff } from 'lucide-react';

export function NoVideoAvailable(): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
      <VideoOff
        size={60}
        className="text-primary mb-4"
        strokeWidth={1.5}
      />
      <p className="font-medium text-high-emphasis-font mb-2">
        No Case Recording Available
      </p>
      <p className="font-normal text-font-700">
        Please try again later.
      </p>
    </div>
  );
}
